import { Box } from '@chakra-ui/react';
import { AdminListPageLayout } from '../../../components/admin-list-page-layout/admin-list-page-layout';
import theme from '../../../theme';
import React, { useEffect, useState } from 'react';
import { BreadCrumbsComponent } from '../../../components/breadcrumbs/breadcrumbsComponent';
import { DataGrid } from '../../../components/data-grid/data-grid';
import {
  EndpointData,
  HTTPMethodType
} from '../../../components/data-grid/data-grid-utils';
import { SubHeader } from '../../organizations/subheader';
import { updatedColDefs } from '../external-application-list';

const endpoint = (appName: string) => {
  const params = [['externalApplicationName', `${appName}`]];
  const endPoint: EndpointData = {
    endPoint: `/externalApplication/users/list/v1`,
    HTTPMethodType: HTTPMethodType.GET,
    params: params
  };
  return endPoint;
};

export const defaultExternalApplicationUser = {
  alias: '',
  userId: undefined,
  username: ''
};

export const ExternalAppUserList: React.FC<AppProps.ExternalApplicationUserListProps> = ({
  columnDefs,
  onAddUser,
  onSelection,
  setStateToDefault,
  sortablePageable,
  selectedAppName = 'External app',
}) => {
  const [pageSize, setPageSize] = useState<number>(25);
  const handleAddUserClick = () => {
    onAddUser(window.location.pathname);
  };

  const handleSelect = (rowData: CMxAPI.ExternalApplicationUser) => {
    onSelection(rowData, window.location.pathname);
  };

  useEffect(() => {
    setStateToDefault && setStateToDefault(defaultExternalApplicationUser);
    // eslint-disable-next-line
  }, []);

  const onPageSizeChange = (pageSize: number) => {
    setPageSize(pageSize);
  };

  return (
    <AdminListPageLayout>
      <Box flexShrink={0}>
        <BreadCrumbsComponent />
      </Box>
      <Box
        flex="1 1 0"
        minHeight={0}
        display="flex"
        flexDirection="column">
        <Box flexShrink={0}>
          <SubHeader
            title={selectedAppName}
            actionName={'Add User'}
            onActionClick={handleAddUserClick}
            pageSize={pageSize}
            onPageSizeChange={onPageSizeChange}
          />
        </Box>
        <Box
          paddingTop={theme.space[16]}
          flex="1 1 0"
          minHeight={0}
          display="flex"
          flexDirection="column">
          <DataGrid
            serverSideInfiniteScroll
            columnDefs={updatedColDefs(columnDefs)}
            endpointData={endpoint(selectedAppName)}
            filterableOptions={sortablePageable.filterableOptions}
            onRowClicked={item => {
              handleSelect(item.data);
            }}
            paginationPageSize={pageSize}
          />
        </Box>
      </Box>
    </AdminListPageLayout>
  );
};
